import { useSelector } from 'react-redux'
import { selectProgramUserContext } from 'utils/contextHelpers'

export function useUserContext() {
  return useSelector(selectProgramUserContext)
}

export function useUserContextWithLoading() {
  const userContext = useUserContext()
  const isUserContextLoading = useSelector(
    state => state.userContextManager?.isFetching,
  )
  const hasUserContext =
    !isUserContextLoading &&
    userContext &&
    Object.keys(userContext).length > 0 &&
    userContext?.sites?.length &&
    userContext?.sites?.[0]

  return {
    userContext,
    isUserContextLoading: !hasUserContext,
  }
}
